import { Row, Table } from "reactstrap";
import { Href } from "../../../Constant";
import { useAppDispatch, useAppSelector } from "../../../Redux-Toolkit/Hooks";
import { Image } from "../../../AbstractElements";
import EmptyCart from "./EmptyCart";
import { dynamicImage } from "../../../Service/DynamicImage";
import { XCircle } from "react-feather";
import { removeCartData } from "../../../Redux-Toolkit/Reducers/CartSlice";
import { CartTableHead } from "./CartTableHead";
import { CartQuantityButton } from "./CartQuantityButton";
import CartAction from "./CartAction";
import { CartType } from "../../../Type/EcommerceType";

export const CartData = () => {
  const dispatch = useAppDispatch();
  const { symbol } = useAppSelector((state) => state.product);
  const { cart } = useAppSelector((state) => state.cartData);
  const removefromcart = (item: CartType) => dispatch(removeCartData(item.id));

  return (
    <>
      {cart && cart.length > 0 ? (
        <Row>
          <div className="order-history theme-scrollbar table-responsive wishlist">
            <Table className="table-bordered">
              <CartTableHead />
              <tbody>
                {cart.map((item, index) => (
                  <tr key={index}>
                    <td><Image className="img-fluid img-40" src={dynamicImage(item.image)} alt={Href} /></td>
                    <td><div className="product-name"><a href={Href}>{item.name}</a></div></td>
                    <td>{symbol}{item.price}</td>
                    <CartQuantityButton item={item} />
                    <td><a href={Href} onClick={() => removefromcart(item)}><XCircle /></a></td>
                    <td>{symbol}{item.price * item.total}</td>
                  </tr>
                ))}
                <CartAction/>
              </tbody>
            </Table>
          </div>
        </Row>
      ) : (
        <EmptyCart />
      )}
    </>
  );
};
